{
    "Absenden": "Send",
    "Bitte prüfe den Link oder frag deine Gastgeber nach einem neuen.": "Please check the link or ask your hosts for a new one.",
    "ca. {seconds} Sek.": "approx. {seconds} sec.",
    "Danke für dein Feedback!": "Thank you for your feedback!",
    "Danke trotzdem, dass du dir Zeit nehmen wolltest!": "Thank you anyway for wanting to take the time!",
    "Danke, dein Feedback ist schon angekommen": "Thank you, your feedback has already arrived",
    "Dein Kommentar (optional)": "Your comment (optional)",
    "Deine Antworten helfen deinen Gastgebern, noch besser zu werden.": "Your answers help your hosts get even better.",
    "Deine Antworten helfen {house}, noch besser zu werden.": "Your answers help {house} get even better.",
    "Deine Antworten sind für den Gastgeber anonym.": "Your answers are anonymous to your host.",
    "Deine Antworten sind gespeichert und werden gesendet, sobald du wieder online bist.": "Your answers are saved and will be sent as soon as you are back online.",
    "Deine Gastgeber haben im Moment keine Umfrage aktiviert. Schau gern später noch einmal vorbei.": "Your hosts have no survey active right now. Feel free to check back later.",
    "Die Umfrage konnte nicht geladen werden. Prüfe deine Internetverbindung.": "The survey could not be loaded. Please check your internet connection.",
    "Diese Umfrage ist nicht mehr verfügbar": "This survey is no longer available",
    "Dieser Link ist ungültig": "This link is invalid",
    "Erneut versuchen": "Try again",
    "Fast oben …": "Almost at the top …",
    "Feedback geben": "Give feedback",
    "Fortschritt": "Progress",
    "Geht so": "So-so",
    "Gerade gibt es keine Umfrage": "No survey right now",
    "Gipfelstürmer": "Summit conqueror",
    "Gut": "Good",
    "Ja": "Yes",
    "Ja, etwas schreiben": "Yes, write something",
    "Keine Verbindung": "No connection",
    "Mehrfachauswahl möglich": "Pick as many as you like",
    "Nein": "No",
    "Nein, fertig": "No, I'm done",
    "Nein, weiter": "No, continue",
    "Noch {count} Fragen": {
        "one": "1 question left",
        "other": "{n} questions left"
    },
    "Schlecht": "Bad",
    "Sehr gut": "Very good",
    "Sehr schlecht": "Very bad",
    "sehr wahrscheinlich": "very likely",
    "Umfrage wird geladen …": "Loading survey …",
    "unwahrscheinlich": "unlikely",
    "Zur Gäste-App": "To the guest app",
    "Zurück zur App": "Back to the app",
    "{value} von 5": "{value} of 5",
    "„{name}“ und alle Einträge darin werden entfernt. Das lässt sich nicht rückgängig machen.": "“{name}” and everything in it will be removed. This cannot be undone.",
    "{count} Adressen in der Nähe": {
        "one": "1 address nearby",
        "other": "{n} addresses nearby"
    },
    "{count} Einträge liegen außerhalb des neuen Zeitraums und sind jetzt wieder ohne Tag.": {
        "one": "One entry falls outside the new dates and has no day now.",
        "other": "{n} entries fall outside the new dates and have no day now."
    },
    "{count} Nächte": {
        "one": "1 night",
        "other": "{n} nights"
    },
    "{count} Orte in der Nähe": {
        "one": "1 place nearby",
        "other": "{n} places nearby"
    },
    "{count} Tipps deiner Gastgeber": {
        "one": "1 tip from your hosts",
        "other": "{n} tips from your hosts"
    },
    "{count} Touren in der Nähe": {
        "one": "1 route nearby",
        "other": "{n} routes nearby"
    },
    "{count}-Tage-Vorhersage": "{count}-day forecast",
    "{day} · {time} Uhr": "{day} · {time}",
    "{day} · ganztägig": "{day} · all day",
    "{day}. {mon} · {time} Uhr": "{mon} {day} · {time}",
    "{feature} gehört zu dir, nicht zum Haus — deine Auswahl und deine Nachrichten bleiben erhalten, wenn du ein Konto anlegst. Alles andere in der App kannst du weiterhin ohne Konto nutzen.": "{feature} belongs to you, not to the house — your selection and your messages are kept once you create an account. Everything else in the app stays available without one.",
    "{feature} ist bald verfügbar.": "{feature} is coming soon.",
    "{feature} steht dir zur Verfügung, sobald deine E-Mail-Adresse bestätigt ist. Öffne dazu den Link, den wir dir geschickt haben.": "{feature} is available as soon as your email address is confirmed. Open the link we sent you.",
    "{from}–{to} Uhr": "{from}–{to}",
    "{label} & Gewitter": "{label} & thunderstorms",
    "{list} & mehr": "{list} & more",
    "{n} hm Aufstieg": "{n} m ascent",
    "{n} km": "{n} km",
    "{n} m": "{n} m",
    "{speed} aus {compass}": "{speed} from {compass}",
    "{time} Uhr": "{time}",
    "{title} zum Planer hinzufügen": "Add {title} to the planner",
    "10 – 21 Uhr": "10 am – 9 pm",
    "25 Min": "25 min",
    "50 Min": "50 min",
    "60 Min": "60 min",
    "7 Tage": "7 days",
    "7 Tage & Details": "7 days & details",
    "80 Min": "80 min",
    "Ab {age} Jahren": "Age {age} and up",
    "ab {amount}": "from {amount}",
    "ab {from} Uhr": "from {from}",
    "Abbrechen": "Cancel",
    "abgesagt": "cancelled",
    "Abmelden": "Sign out",
    "Abreise": "Departure",
    "AGB": "Terms",
    "Aktualisiert {time} Uhr": "Updated {time}",
    "Aktuell nichts geplant": "Nothing planned right now",
    "Alle": "All",
    "Alle ausklappen": "Expand all",
    "Alle einklappen": "Collapse all",
    "Alle Empfehlungen": "All recommendations",
    "Alle Events": "All events",
    "Alles eingeplant. Neue Favoriten landen hier.": "Everything is scheduled. New favourites land here.",
    "Alles klar": "Got it",
    "Alles zeigen": "Show all",
    "Als Gast angemeldet": "Signed in as a guest",
    "Als Gast fortfahren": "Continue as a guest",
    "Als Nächstes": "Up next",
    "Am Haus": "At the house",
    "Änderungen speichern": "Save changes",
    "Anmelden": "Sign in",
    "Anmeldung erforderlich": "Registration required",
    "Anmeldung fehlgeschlagen. Du kannst auch als Gast fortfahren.": "Sign-in failed. You can also continue as a guest.",
    "Anreise": "Arrival",
    "Ansehen": "View",
    "Architektur": "Architecture",
    "Auf die Tage verteilen": "Spread across your days",
    "Aufenthalt": "Stay",
    "Aufguss-Zeremonie": "Sauna infusion ceremony",
    "Aus dem Planer entfernt.": "Removed from the planner.",
    "Aussichtspunkt": "Viewpoint",
    "ausverkauft": "sold out",
    "Ausverkauft": "Sold out",
    "Bäckerei": "Bakery",
    "Bad & Badestelle": "Pool & bathing spot",
    "Bar": "Bar",
    "Barrierefrei zugänglich": "Step-free access",
    "Behandlungen": "Treatments",
    "Berghütte": "Mountain hut",
    "bestätigt": "confirmed",
    "Bewölkt": "Cloudy",
    "Bewölkung": "Cloud cover",
    "Biergarten": "Beer garden",
    "Bild {i} von {total} vergrößern": "Enlarge image {i} of {total}",
    "Bild vergrößern": "Enlarge image",
    "Bilder": "Photos",
    "Bitte bestätige deine E-Mail": "Please confirm your email",
    "Bitte gib dein Passwort ein.": "Please enter your password.",
    "Bitte gib deinem Reiseplan einen Namen.": "Please give your trip plan a name.",
    "Bitte gib deinen Namen ein.": "Please enter your name.",
    "Bitte gib den Zeitraum deiner Reise an.": "Please enter the dates of your trip.",
    "Bitte gib eine gültige E-Mail-Adresse ein.": "Please enter a valid email address.",
    "Bitte schreib zuerst eine Nachricht.": "Please write a message first.",
    "Bitte überprüfe deine Eingaben.": "Please check your entries.",
    "Bitte versuche es später erneut.": "Please try again later.",
    "Böen": "Gusts",
    "Bootsverleih": "Boat rental",
    "Brauerei": "Brewery",
    "Bücherei": "Library",
    "Burg & Schloss": "Castle & palace",
    "ca. {duration}": "approx. {duration}",
    "Café": "Café",
    "Chat": "Chat",
    "Check-in / Check-out": "Check-in / check-out",
    "Check-in und Check-out legen wir automatisch auf deinen ersten und letzten Tag.": "We put check-in and check-out on your first and last day automatically.",
    "Check-out": "Check-out",
    "Club": "Club",
    "da bist.": "have you here.",
    "Dafür brauchst du ein Konto": "You need an account for this",
    "Dafür fehlt dir die Berechtigung. Melde dich neu an.": "You do not have permission for this. Please sign in again.",
    "Das dauert nur einen Augenblick.": "This only takes a moment.",
    "Das geht nicht mehr — du hast das Maximum erreicht.": "That is no longer possible — you have reached the maximum.",
    "Das hat nicht": "That did not",
    "Das Passwort braucht mindestens 8 Zeichen.": "Your password needs at least 8 characters.",
    "Das Wetter ist gerade nicht verfügbar.": "The weather is not available right now.",
    "Datenschutz": "Privacy",
    "Dauert unter einer Minute.": "Takes less than a minute.",
    "Dein Aufenthalt": "Your stay",
    "Dein digitaler Begleiter für den Aufenthalt: alles zu deinem Haus und deiner Region an einem Ort.": "Your digital companion for the stay: everything about your house and your region in one place.",
    "Dein Gastgeber": "Your host",
    "Dein Gastgeber hat hier noch keine Informationen hinterlegt. Schau später noch einmal vorbei — oder frag einfach direkt nach.": "Your host has not put any information here yet. Look again later — or simply ask them directly.",
    "Dein Gastgeber, {name}": "Your host, {name}",
    "Dein Planer": "Your planner",
    "Deine E-Mail-Adresse ist bestätigt.": "Your email address is confirmed.",
    "Deine Gastgeber": "Your hosts",
    "Deine Gastgeber haben hier noch nichts empfohlen.": "Your hosts have not recommended anything here yet.",
    "Deine Region,": "Your region,",
    "Deine Reisepläne konnten nicht geladen werden. Versuch es später noch einmal.": "Your trip plans could not be loaded. Please try again later.",
    "deinem Gastgeber": "your host",
    "deiner Gastgeber": "from your hosts",
    "Denkmal": "Monument",
    "Der Chat": "The chat",
    "Der Chat konnte nicht geladen werden. Zieh nach unten oder versuch es später noch einmal.": "The chat could not be loaded. Pull down or try again later.",
    "Der Eintrag konnte nicht entfernt werden.": "The entry could not be removed.",
    "Der Eintrag konnte nicht hinzugefügt werden.": "The entry could not be added.",
    "Der Eintrag konnte nicht verschoben werden.": "The entry could not be moved.",
    "Der Reiseplan konnte nicht erstellt werden.": "The trip plan could not be created.",
    "Der Reiseplan konnte nicht gelöscht werden.": "The trip plan could not be deleted.",
    "Der Reiseplan konnte nicht geöffnet werden.": "The trip plan could not be opened.",
    "Der Reiseplan konnte nicht gespeichert werden.": "The trip plan could not be saved.",
    "Details": "Details",
    "Die Abreise kann nicht vor der Anreise liegen.": "Departure cannot be before arrival.",
    "Die Empfehlungen konnten nicht geladen werden.": "The recommendations could not be loaded.",
    "Die Empfehlungen konnten nicht geladen werden. Bitte versuche es später noch einmal.": "The recommendations could not be loaded. Please try again later.",
    "Die Karte konnte nicht geladen werden.": "The map could not be loaded.",
    "Die Nachricht konnte nicht gesendet werden.": "The message could not be sent.",
    "Die Registrierung hat nicht geklappt. Bitte versuche es später erneut.": "Registration did not work. Please try again later.",
    "Die Reihenfolge konnte nicht gespeichert werden.": "The order could not be saved.",
    "Die Veranstaltungen konnten gerade nicht geladen werden. Bitte versuche es später noch einmal.": "The events could not be loaded just now. Please try again later.",
    "Diese Funktion ist bald verfügbar.": "This feature is coming soon.",
    "Diese Nachricht ist zu lang.": "This message is too long.",
    "Diese Unterkunft ist noch nicht freigeschaltet — Empfehlungen aus der Region erscheinen hier, sobald sie es ist.": "This property is not activated yet — regional recommendations will appear here once it is.",
    "Dieser Bereich": "This area",
    "Dieser Chat ist nicht mehr verfügbar.": "This chat is no longer available.",
    "Dieser Eintrag ist nicht mehr verfügbar.": "This entry is no longer available.",
    "Dieser Link ist unvollständig.": "This link is incomplete.",
    "Dieser Link wurde bereits verwendet oder ist nicht mehr gültig. Versuche dich anzumelden — dein Konto ist möglicherweise schon aktiv.": "This link has already been used or is no longer valid. Try signing in — your account may already be active.",
    "Direkt verbunden": "Directly connected",
    "Download": "Download",
    "Du kannst dich jetzt anmelden und deine Gästemappe nutzen.": "You can sign in now and use your guest directory.",
    "E-Mail": "Email",
    "E-Mail bestätigen": "Confirm your email",
    "E-Mail noch nicht bestätigt": "Email not confirmed yet",
    "Ein Reiseplan kann höchstens 60 Tage umfassen.": "A trip plan can cover at most 60 days.",
    "Einen Moment …": "One moment …",
    "Einstellungen": "Settings",
    "Eintritt auf Spendenbasis": "Admission by donation",
    "Eintritt frei": "Free admission",
    "Eisdiele": "Ice cream parlour",
    "Empfehlungen": "Recommendations",
    "Empfehlungen für deinen Zeitraum": "Recommendations for your dates",
    "Empfehlungen für dich": "Recommendations for you",
    "Endgültig löschen": "Delete permanently",
    "Entdecken": "Discover",
    "entdeckt.": "discovered.",
    "Entfernen": "Remove",
    "Erstmal ohne Konto ansehen": "Look around without an account first",
    "Events": "Events",
    "Events & Erlebnisse": "Events & experiences",
    "Fast geschafft": "Almost there",
    "Favoriten sammeln": "Collect favourites",
    "Findet draußen statt": "Takes place outdoors",
    "Fragen zum Check-in, ein Tipp für heute Abend oder eine Bitte — {name} antwortet dir hier direkt.": "Questions about check-in, a tip for tonight or a request — {name} answers you right here.",
    "frei nutzbar": "free to use",
    "Frühling": "Spring",
    "Führung": "Guided tour",
    "Für den Chat brauchst du ein bestätigtes Konto.": "You need a confirmed account for the chat.",
    "Für die nächsten Stunden liegt keine Vorhersage vor.": "There is no forecast for the coming hours.",
    "Für die nächsten Tage sind noch keine Veranstaltungen eingetragen. Frag gern deinen Gastgeber — oft gibt es kurzfristige Tipps.": "No events are listed for the coming days. Do ask your host — there are often last-minute tips.",
    "Für diese E-Mail-Adresse gibt es schon ein Konto. Bitte melde dich stattdessen an.": "There is already an account for this email address. Please sign in instead.",
    "Für diese Kategorie gibt es hier noch keine Einträge.": "There are no entries in this category yet.",
    "Für diese Unterkunft ist der Planer nicht verfügbar.": "The planner is not available for this property.",
    "Für diese Unterkunft ist keine Kartenquelle hinterlegt.": "No map source is configured for this property.",
    "Für Familien geeignet": "Family friendly",
    "Für Hausgäste": "For house guests",
    "Galerie": "Gallery",
    "ganztägig": "all day",
    "Gast": "Guest",
    "Gästemappe": "Guest directory",
    "Gastgeber": "Host",
    "Gastgeber fragen": "Ask your host",
    "Gastronomie": "Food & drink",
    "Gehört zu deinem Aufenthalt": "Part of your stay",
    "geklappt": "work",
    "Gelesen": "Read",
    "Geotop": "Geosite",
    "Geschäft": "Shop",
    "geschlossen": "closed",
    "Gesichtsbehandlung Natur": "Natural facial treatment",
    "Gestern": "Yesterday",
    "Gib deinem Reiseplan einen Namen und verrate uns den Zeitraum deines Aufenthalts. Danach sammelst du überall in der App Favoriten mit „Zum Planer hinzufügen“ und verteilst sie auf deine Tage.": "Give your trip plan a name and tell us the dates of your stay. After that you collect favourites anywhere in the app with “Add to planner” and spread them across your days.",
    "GPX-Track laden": "Download GPX track",
    "Gut zu wissen": "Good to know",
    "Habt ihr einen Tipp für heute Abend?": "Do you have a tip for tonight?",
    "Hallo {name},": "Hello {name},",
    "Häufige Fragen": "Frequently asked questions",
    "Hauptnavigation": "Main navigation",
    "Heiter": "Fair",
    "Herbst": "Autumn",
    "Herzlich willkommen —": "A warm welcome —",
    "Heute": "Today",
    "Heute {hours}": "Today {hours}",
    "Heute geschlossen": "Closed today",
    "Heute im Detail": "Today in detail",
    "Hin und zurück": "Out and back",
    "Hinzufügen": "Add",
    "Historische Stätte": "Historic site",
    "Historischer Kern": "Historic centre",
    "Hofladen": "Farm shop",
    "Höhle": "Cave",
    "Home": "Home",
    "Hunde erlaubt": "Dogs allowed",
    "Ich akzeptiere die": "I accept the",
    "Im Freien": "Outdoors",
    "Impressum": "Legal notice",
    "In der Region": "In the region",
    "In dieser Auswahl steht gerade nichts an.": "Nothing is coming up in this selection.",
    "inkl.": "incl.",
    "Jetzt": "Now",
    "Kanutour": "Canoe trip",
    "Karte": "Map",
    "Kein Download nötig — die App lebt in deinem Browser.": "No download needed — the app lives in your browser.",
    "Kein Konto mit dieser E-Mail-Adresse gefunden.": "No account found for this email address.",
    "Kinderwagentauglich": "Stroller friendly",
    "Kino": "Cinema",
    "Kirche": "Church",
    "Klar": "Clear",
    "Klassische Rückenmassage": "Classic back massage",
    "Klettertour": "Climbing route",
    "Kloster": "Monastery",
    "Können wir später einchecken?": "Can we check in later?",
    "Konto": "Account",
    "Konto erstellen": "Create an account",
    "Kräuterstempel-Massage": "Herbal stamp massage",
    "Langlaufloipe": "Cross-country ski trail",
    "Laufstrecke": "Running route",
    "Leicht": "Easy",
    "Leichte Schauer": "Light showers",
    "Leichte Schneeregenschauer": "Light sleet showers",
    "Leichte Schneeschauer": "Light snow showers",
    "Leichter Regen": "Light rain",
    "Leichter Schneefall": "Light snow",
    "Leichter Schneeregen": "Light sleet",
    "Letzter Schritt": "Last step",
    "Link ungültig": "Link invalid",
    "Liste": "List",
    "Los geht's": "Let’s go",
    "Löschen": "Delete",
    "Luftdruck": "Pressure",
    "Luftfeuchte": "Humidity",
    "Mehr": "More",
    "Mehr erfahren": "Learn more",
    "Mein Planer": "My planner",
    "Mein Reiseplan": "My trip plan",
    "Meine Buchungen": "My bookings",
    "Meine Reise · {house}": "My trip · {house}",
    "Menü": "Menu",
    "Menü öffnen": "Open menu",
    "Menü schließen": "Close menu",
    "Merken": "Save",
    "Mindestens 8 Zeichen": "At least 8 characters",
    "Mittel": "Moderate",
    "Morgen": "Tomorrow",
    "Mountainbike": "Mountain biking",
    "Mühle": "Mill",
    "Museum": "Museum",
    "N": "N",
    "Nach oben": "Move up",
    "Nach unten": "Move down",
    "Nachname": "Last name",
    "Nachricht schreiben …": "Write a message …",
    "Nächstes Bild": "Next image",
    "Name deines Reiseplans": "Name of your trip plan",
    "Name und Zeitraum deiner Reise.": "The name and dates of your trip.",
    "Natur": "Nature",
    "Naturinformation": "Nature information",
    "Nebel": "Fog",
    "Neuen Link anfordern": "Request a new link",
    "Neuen Reiseplan anlegen": "Create a new trip plan",
    "Nicht mehr verfügbar": "No longer available",
    "Nichts angekommen? Sieh auch im Spam-Ordner nach.": "Nothing arrived? Check your spam folder too.",
    "Nichts angekommen? Sieh im Spam-Ordner nach — die Nachricht kann einen Moment brauchen.": "Nothing arrived? Check your spam folder — the message can take a moment.",
    "Niederschlag": "Precipitation",
    "NNO": "NNE",
    "NNW": "NNW",
    "NO": "NE",
    "Noch kein Konto?": "No account yet?",
    "Noch kein Reiseplan": "No trip plan yet",
    "Notfallkontakte": "Emergency contacts",
    "Nur das Nötigste — in unter einer Minute fertig.": "Only the essentials — done in under a minute.",
    "NW": "NW",
    "O": "E",
    "oder": "or",
    "Öffne den Link in der E-Mail an {email}, dann ist dein Konto startklar.": "Open the link in the email to {email} and your account is ready to go.",
    "Öffnungszeiten": "Opening hours",
    "ONO": "ENE",
    "Ort wird noch bekannt gegeben": "Venue to be announced",
    "OSO": "ESE",
    "Park & Garten": "Park & garden",
    "Parkmöglichkeit": "Parking",
    "Passwort": "Password",
    "Passwort anzeigen": "Show password",
    "Passwort verbergen": "Hide password",
    "Passwort vergessen?": "Forgot your password?",
    "Pilgerweg": "Pilgrimage route",
    "Plane deine Reise — Tag für Tag.": "Plan your trip — day by day.",
    "Planer": "Planner",
    "Radtour": "Cycle route",
    "Regen": "Rain",
    "Regenschauer": "Showers",
    "Region": "Region",
    "Region-Tipps": "Regional tips",
    "Regionale Vorhersage für {place}.": "Regional forecast for {place}.",
    "Regionale Vorhersage.": "Regional forecast.",
    "Registrieren": "Register",
    "Reiseplan angelegt.": "Trip plan created.",
    "Reiseplan anlegen": "Create trip plan",
    "Reiseplan bearbeiten": "Edit trip plan",
    "Reiseplan erstellen": "Create a trip plan",
    "Reiseplan gelöscht.": "Trip plan deleted.",
    "Reiseplan gespeichert.": "Trip plan saved.",
    "Reiseplan löschen": "Delete trip plan",
    "Reiseplan löschen?": "Delete trip plan?",
    "Reiseplan wählen": "Choose trip plan",
    "Reittour": "Riding trail",
    "Rennrad": "Road cycling",
    "Reservierung erforderlich": "Reservation required",
    "Restaurant": "Restaurant",
    "Restaurants": "Restaurants",
    "Restaurants, Sehenswürdigkeiten und Touren in deiner Nähe — als Liste oder auf der Karte.": "Restaurants, sights and routes near you — as a list or on the map.",
    "Route starten": "Start navigation",
    "Ruine": "Ruin",
    "Rundweg": "Loop",
    "S": "S",
    "Sächsische Schweiz": "Saxon Switzerland",
    "Sammle alles, was dich interessiert, und ordne deine Tage so, wie es dir passt.": "Collect everything that interests you and arrange your days the way you like.",
    "Sauna & Pool": "Sauna & pool",
    "Schließen": "Close",
    "Schneefall": "Snow",
    "Schneeregen": "Sleet",
    "Schneeregenschauer": "Sleet showers",
    "Schneeschauer": "Snow showers",
    "Schneeschuhtour": "Snowshoe tour",
    "Schnellzugriff": "Quick access",
    "schön dass du da bist.": "good to have you here.",
    "Schon registriert?": "Already registered?",
    "Schön, dass du": "Good to",
    "schön, dass du da bist.": "good to have you here.",
    "Schreib deinen Gastgebern": "Write to your hosts",
    "Schreib deinen Gastgebern jederzeit — oder frag den Concierge, wenn es schnell gehen soll.": "Write to your hosts at any time — or ask the concierge when it needs to be quick.",
    "Schreib uns – wir antworten schnell.": "Write to us – we answer quickly.",
    "Schritt {step} von {total}": "Step {step} of {total}",
    "Schwer": "Difficult",
    "See": "Lake",
    "Sehenswertes": "Point of interest",
    "Sehenswürdigkeit": "Sight",
    "Sehenswürdigkeiten": "Sights",
    "Sehr schwer": "Very difficult",
    "Senden": "Send",
    "Services": "Services",
    "SO": "SE",
    "So. 11:00 Uhr": "Sun 11:00",
    "Sommer": "Summer",
    "Sonnig": "Sunny",
    "Sonstiges": "Other",
    "Spa & Wellness": "Spa & wellness",
    "Spaziergang": "Walk",
    "Spielplatz": "Playground",
    "Sport": "Sport",
    "Sprache": "Language",
    "SSO": "SSE",
    "SSW": "SSW",
    "Stadtrundgang": "City walk",
    "Starke Schauer": "Heavy showers",
    "Starke Schneeregenschauer": "Heavy sleet showers",
    "Starke Schneeschauer": "Heavy snow showers",
    "Starker Regen": "Heavy rain",
    "Starker Schneefall": "Heavy snow",
    "Starker Schneeregen": "Heavy sleet",
    "Steht schon in deinem Planer.": "Already in your planner.",
    "Streckentour": "Point to point",
    "Stündlich": "Hourly",
    "SW": "SW",
    "Tag {n}": "Day {n}",
    "Tagesplanung": "Day planning",
    "Taupunkt": "Dew point",
    "Teilen": "Share",
    "Teilen nicht möglich.": "Sharing is not possible.",
    "Teils bewölkt": "Partly cloudy",
    "Termin anfragen": "Request an appointment",
    "Termin buchen": "Book an appointment",
    "Termin folgt": "Date to follow",
    "Theater & Bühne": "Theatre & stage",
    "Ticket erforderlich": "Ticket required",
    "Tickets": "Tickets",
    "Tipps & Events aus der Region erhalten": "Receive tips & events from the region",
    "Tour": "Route",
    "Touren": "Routes",
    "Tourist-Information": "Tourist information",
    "Überspringen": "Skip",
    "UV-Index": "UV index",
    "Veranstaltung": "Event",
    "Veranstaltungen": "Events",
    "Veranstaltungen nicht verfügbar": "Events unavailable",
    "Veranstaltungsort": "Venue",
    "Vergangene Reise. Sie bleibt ein Jahr lang für dich gespeichert.": "Past trip. It stays saved for you for one year.",
    "Vergrößern": "Zoom in",
    "Verkehr": "Transport",
    "Verkleinern": "Zoom out",
    "Verschieben": "Move",
    "Verstanden": "Understood",
    "Vom Haus": "From the house",
    "Vorheriges Bild": "Previous image",
    "Vorhersage": "Forecast",
    "Vorname": "First name",
    "W": "W",
    "Wanderung": "Hike",
    "Wann gibt es Frühstück?": "When is breakfast?",
    "Was dich erwartet": "What to expect",
    "Wasserfall": "Waterfall",
    "WC": "Toilet",
    "Weinabend, Sonnenaufgangstour, Konzert im Fels — alles im Haus und in der Region, mit einem Tipp gebucht.": "A wine evening, a sunrise hike, a concert in the rocks — everything in the house and the region, booked with one tap.",
    "Weingut": "Winery",
    "Weiter": "Continue",
    "Weitere Termine": "Further dates",
    "Wellness & Sauna": "Wellness & sauna",
    "Wetter": "Weather",
    "Wetter nicht verfügbar": "Weather unavailable",
    "Wetter und Vorhersage": "Weather and forecast",
    "Wetter wird geladen …": "Loading weather …",
    "Wetterdaten:": "Weather data:",
    "Willkommen": "Welcome",
    "Willkommen zurück": "Welcome back",
    "Wind": "Wind",
    "Winter": "Winter",
    "Winterwanderung": "Winter hike",
    "Wir haben dir eine Nachricht geschickt.": "We have sent you a message.",
    "Wir haben dir einen Bestätigungslink geschickt. Öffne ihn, damit dein Konto vollständig aktiv ist. Bis dahin kannst du die App schon nutzen.": "We have sent you a confirmation link. Open it so your account is fully active. Until then you can already use the app.",
    "Wir konnten deinen Link nicht bestätigen.": "We could not confirm your link.",
    "Wir melden uns mit einem Terminvorschlag.": "We will get back to you with a proposed time.",
    "Wir prüfen deinen Bestätigungslink.": "We are checking your confirmation link.",
    "Wird geladen …": "Loading …",
    "WLAN, Frühstück, Check-out & mehr": "Wi-Fi, breakfast, check-out & more",
    "WNW": "WNW",
    "WSW": "WSW",
    "z. B. Wochenende in der Sächsischen Schweiz": "e.g. Weekend in Saxon Switzerland",
    "Zeitraum festlegen": "Set your dates",
    "Zieh eine Attraktion hierher.": "Drag an attraction here.",
    "Zimmerservice": "Room service",
    "Zoo & Tierpark": "Zoo & wildlife park",
    "Zu diesen Einträgen sind keine Koordinaten hinterlegt.": "No coordinates are stored for these entries.",
    "Zugang verweigert. Prüfe deine Zugangsdaten.": "Access denied. Please check your credentials.",
    "Zum Planer hinzufügen": "Add to planner",
    "Zur Anmeldung": "To sign-in",
    "Zur Website": "Visit website",
    "Zurück": "Back",
    "App zum Home-Bildschirm hinzufügen": "Add the app to your home screen",
    "Tippe auf „Teilen“ (Quadrat mit Pfeil nach oben — in Safari unten, in anderen Browsern oben) und wähle „Zum Home-Bildschirm“. Danach öffnest du die App direkt von dort — ohne Browserleiste.": "Tap “Share” (the square with an arrow pointing up — at the bottom in Safari, at the top in other browsers) and choose “Add to Home Screen”. From then on you open the app right from there — without the browser bar.",
    "Installieren": "Install",
    "Neue Version der Gäste-App verfügbar.": "A new version of the guest app is available.",
    "Aktualisieren": "Update",
    "Keine Verbindung — du siehst die zuletzt geladenen Inhalte.": "No connection — you are seeing the content loaded last.",
    "Link kopiert.": "Link copied.",
    "App installieren": "Install app",
    "Der Bildschirm kann gerade nicht angelassen werden.": "The screen can't be kept on right now.",
    "An": "On",
    "Aus": "Off",
    "Bildschirm anlassen, solange du der Tour folgst": "Keep the screen on while you follow the tour",
    "Als App auf den Home-Bildschirm — auch offline nutzbar.": "Add to your home screen as an app — works offline too.",
    "Concierge": "Concierge",
    "KI-Concierge · {house}": "AI concierge · {house}",
    "Das hat nicht geklappt. Bitte versuch es noch einmal.": "That didn't work. Please try again.",
    "Direkt an {name} schreiben": "Write to {name} directly",
    "Concierge fragen": "Ask the concierge",
    "Ohne Konto antwortet hier nur der Concierge. Um deinen Gastgebern direkt zu schreiben, brauchst du ein bestätigtes Konto.": "Without an account, only the concierge answers here. To write to your hosts directly, you need a confirmed account.",
    "Soll ich das an {name} weitergeben?": "Shall I pass this on to {name}?",
    "Ja, weitergeben": "Yes, pass it on",
    "Nein, danke": "No, thanks",
    "Der Concierge schreibt …": "The concierge is typing …",
    "Frag den Concierge …": "Ask the concierge …",
    "Der Concierge ist gerade nicht erreichbar. Mit einem bestätigten Konto kannst du deinen Gastgebern direkt schreiben.": "The concierge is not available right now. With a confirmed account you can write to your hosts directly.",
    "Du schreibst jetzt direkt mit {name}. Die Antwort kommt hier.": "You are now writing directly to {name}. The reply will arrive here.",
    "Der Concierge antwortet wieder. Deine Gastgeber lesen weiter mit.": "The concierge is answering again. Your hosts can still read along.",
    "Der Concierge ist gerade nicht verfügbar. Deine Nachricht ist bei {name} angekommen — die Antwort kommt hier.": "The concierge is not available right now. Your message has reached {name} — the reply will arrive here.",
    "Dein Name wurde gespeichert.": "Your name has been saved.",
    "Dein Name konnte nicht gespeichert werden. Bitte versuche es später erneut.": "Your name could not be saved. Please try again later.",
    "Bitte gib dein aktuelles Passwort ein.": "Please enter your current password.",
    "Das neue Passwort muss sich vom aktuellen unterscheiden.": "The new password must be different from the current one.",
    "Die Passwörter stimmen nicht überein.": "The passwords do not match.",
    "Dein Passwort wurde geändert.": "Your password has been changed.",
    "Das aktuelle Passwort stimmt nicht.": "The current password is incorrect.",
    "Das Passwort konnte nicht geändert werden. Bitte versuche es später erneut.": "The password could not be changed. Please try again later.",
    "Dein Konto": "Your account",
    "Du nutzt die App ohne Konto": "You're using the app without an account",
    "Mit einem Konto kannst du deinen Namen und dein Passwort hier verwalten.": "With an account you can manage your name and password here.",
    "Dein Name": "Your name",
    "Name": "Name",
    "Name speichern": "Save name",
    "Passwort ändern": "Change password",
    "Aktuelles Passwort": "Current password",
    "Neues Passwort": "New password",
    "Mindestens {count} Zeichen.": "At least {count} characters.",
    "Neues Passwort wiederholen": "Repeat new password",
    "Hallo,": "Hello,",
    "Die App ist installiert": "The app is installed",
    "Du findest sie auf deinem Home-Bildschirm und öffnest sie von dort direkt — ohne Browserleiste.": "You'll find it on your home screen and can open it straight from there — without the browser bar.",
    "Zur Startseite": "To the home page",
    "Direkt vom Home-Bildschirm starten": "Launch straight from your home screen",
    "Im Vollbild, ohne Browserleiste": "Full screen, without the browser bar",
    "Gästemappe auch ohne Internet": "Guest folder even without internet",
    "Jetzt installieren": "Install now",
    "Dein Browser fragt noch einmal nach — bestätige dort mit „Installieren“.": "Your browser will ask once more — confirm with “Install”.",
    "So geht’s in drei Schritten": "Here's how, in three steps",
    "Tippe auf „Teilen“": "Tap “Share”",
    "In Safari unten in der Leiste, in anderen Browsern oben rechts.": "In Safari it's in the bar at the bottom, in other browsers at the top right.",
    "Wähle „Zum Home-Bildschirm“": "Choose “Add to Home Screen”",
    "Falls du es nicht siehst, scrolle im Menü etwas nach unten.": "If you don't see it, scroll down a little in the menu.",
    "Tippe oben rechts auf „Hinzufügen“": "Tap “Add” at the top right",
    "Fertig — die App liegt jetzt auf deinem Home-Bildschirm.": "Done — the app is now on your home screen.",
    "Dieser Browser kann die App nicht installieren. Öffne die Seite in Chrome (Android) oder Safari (iPhone und iPad) und tippe dort auf „App installieren“.": "This browser can't install the app. Open the page in Chrome (Android) or Safari (iPhone and iPad) and tap “Install app” there.",
    "Die App ist installiert. Du findest sie jetzt auf deinem Home-Bildschirm.": "The app is installed. You'll now find it on your home screen.",
    "Der Link konnte nicht angefordert werden. Bitte versuche es später erneut.": "The link could not be requested. Please try again later.",
    "Link anfordern": "Request link",
    "Zurück zur Anmeldung": "Back to sign-in",
    "Schau in dein Postfach": "Check your inbox",
    "Dieser Link ist abgelaufen. Bitte fordere einen neuen an.": "This link has expired. Please request a new one.",
    "Dieser Link wurde bereits verwendet oder ist nicht mehr gültig.": "This link has already been used or is no longer valid.",
    "Passwort geändert": "Password changed",
    "Neues Passwort vergeben": "Choose a new password",
    "Wähle ein neues Passwort für dein Konto.": "Choose a new password for your account.",
    "Passwort speichern": "Save password",
    "Wir schicken dir einen Link, mit dem du ein neues Passwort vergibst.": "We will send you a link to choose a new password.",
    "Der Link ist 2 Stunden gültig.": "The link is valid for 2 hours.",
    "Falls zu {email} ein Konto existiert, haben wir dir einen Link zum Zurücksetzen geschickt.": "If an account exists for {email}, we have sent you a link to reset your password.",
    "Dein neues Passwort ist gespeichert.": "Your new password has been saved.",
    "Aus Sicherheitsgründen wurdest du auf allen Geräten abgemeldet. Melde dich mit deinem neuen Passwort an.": "For security reasons you have been signed out on all devices. Sign in with your new password.",
    "Du bist bereits angemeldet. Dein Passwort änderst du in den Einstellungen.": "You are already signed in. You can change your password in the settings.",
    "Dieser Link ist abgelaufen. Fordere nach dem Anmelden einen neuen an — oder registriere dich mit derselben Adresse noch einmal.": "This link has expired. Request a new one after signing in — or sign up again with the same address.",
    "Wir haben dir einen neuen Link an {email} geschickt.": "We have sent a new link to {email}.",
    "Link erneut senden": "Send link again",
    "Benachrichtigungen sind aktiviert.": "Notifications are on.",
    "Benachrichtigungen konnten nicht geändert werden.": "Notifications could not be changed.",
    "Auf dem iPhone kommen Benachrichtigungen nur in der installierten App an. Füge die App zuerst zum Home-Bildschirm hinzu.": "On iPhone, notifications only reach the installed app. Add the app to your Home Screen first.",
    "Benachrichtigungen sind für diese Seite blockiert. Du kannst sie in den Einstellungen deines Browsers wieder erlauben.": "Notifications are blocked for this site. You can allow them again in your browser settings.",
    "Erhalte Hinweise zu deinem Aufenthalt, Veranstaltungen und Neuigkeiten aus dem Haus.": "Get notes about your stay, events and news from the house.",
    "Du erhältst Benachrichtigungen von diesem Haus auf diesem Gerät.": "You receive notifications from this house on this device.",
    "Benachrichtigungen": "Notifications",
    "Neuigkeiten vom Gastgeber erhalten": "Get news from your host",
    "Unterkunft": "Accommodation",
    "Der Wechsel hat nicht geklappt. Bitte versuche es erneut.": "Switching didn't work. Please try again.",
    "Deine Anmeldung konnte nicht übernommen werden. Bitte melde dich an.": "We couldn't carry over your sign-in. Please sign in.",
    "Seite nicht gefunden": "Page not found",
    "Diese Seite gibt es nicht": "This page doesn't exist",
    "Unter dieser Adresse ist keine Gäste-App zu finden. Vielleicht hat sich ein Tippfehler eingeschlichen — oder die Unterkunft ist noch nicht freigeschaltet.": "There is no guest app at this address. Perhaps there is a typo in the link — or the accommodation has not been activated yet.",
    "Bitte prüfe den Link oder scanne den QR-Code deiner Unterkunft erneut.": "Please check the link or scan your accommodation's QR code again.",
    "Vorschau · Entwurf — für Gäste noch nicht sichtbar": "Preview · Draft — not yet visible to guests",
    "Läuft gerade": "Happening now",
    "Alle Veranstaltungen der Region.": "All events in the region.",
    "Veranstaltungen bis {km} km Entfernung.": "Events up to {km} km away.",
    "Nur in der Nähe anzeigen": "Show nearby only",
    "Auch weiter entfernte anzeigen": "Also show events further away",
    "Notruf": "Emergency call",
    "Feuerwehr & Rettungsdienst": "Fire brigade & ambulance",
    "Polizei": "Police",
    "Hat begonnen": "Has started",
    "Der Link ist veraltet oder unvollständig. Auf der Startseite findest du alles rund um deinen Aufenthalt.": "The link is outdated or incomplete. The home page has everything about your stay.",
    "Eingeplant für {day}": "Planned for {day}",
    "Gemerkt — noch ohne Tag.": "Saved — no day yet.",
    "Findet am {day} statt": "Takes place on {day}",
    "Termin: {day}": "Date: {day}",
    "Tag wählen": "Choose a day",
    "Noch ohne Tag": "No day yet",
    "Gemerkt, noch ohne Tag": "Saved, no day yet",
    "Wähle für jeden Eintrag einen Tag oder zieh ihn am Symbol dorthin. Die Pfeile ändern die Reihenfolge innerhalb eines Tages. Veranstaltungen mit Termin stehen schon an ihrem Tag.": "Pick a day for each entry, or drag it there by its icon. The arrows change the order within a day. Events with a date are already on their day.",
    "Verschoben auf {day}": "Moved to {day}",
    "{day} um {time} Uhr": "{day} at {time}",
    "Termin steht fest": "This event has a fixed date",
    "„{title}“ findet am {when} statt. Trotzdem auf {day} legen?": "“{title}” takes place on {when}. Put it on {day} anyway?",
    "Trotzdem verschieben": "Move anyway",
    "Infos zum Haus": "About the house",
    "Mein Apartment": "My apartment",
    "Service & Angebote": "Services & offers",
    "Rund um den Aufenthalt": "During your stay",
    "Anreise & Mobilität": "Getting here & around",
    "Sicherheit & Notfall": "Safety & emergencies",
    "Konzerte & Musik": "Concerts & music",
    "Party & Nachtleben": "Parties & nightlife",
    "Feste & Festivals": "Fêtes & festivals",
    "Märkte": "Markets",
    "Shows & Performances": "Shows & performances",
    "Comedy & Kabarett": "Comedy & cabaret",
    "Film & Kino": "Film & cinema",
    "Ausstellungen & Kunst": "Exhibitions & art",
    "Lesungen & Literatur": "Readings & literature",
    "Vorträge & Bildung": "Talks & learning",
    "Führungen & Touren": "Guided tours",
    "Sport & Bewegung": "Sports & activity",
    "Kinder & Familie": "Kids & family",
    "Essen & Trinken": "Food & drink",
    "Workshops & Kurse": "Workshops & courses",
    "Brauchtum & Tradition": "Customs & tradition",
    "Concierge von {house}": "{house} concierge",
    "Willkommen im {house}! Ich bin der digitale Concierge und beantworte deine Fragen rund um den Aufenthalt — jederzeit. Für alles andere leite ich dich gern an deine Gastgeber weiter.": "Welcome to {house}! I'm the digital concierge and answer your questions about your stay — any time. For anything else, I'm happy to pass you on to your hosts.",
    "KI": "AI",
    "Check-in & Ankommen": "Check-in & arrival",
    "{address} in Google Maps öffnen": "Open {address} in Google Maps"
}
